import { Divider, Group, Paper, Stack, Text } from '@mantine/core';
import { formatAbbreviatedCurrency } from 'src/common/currency';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type AumAndFreshnessCardProps = {
  connectedAum: number;
  healthyProviderCount: number;
  totalProviderCount: number;
};

function StatSection({
  label,
  value,
  description,
}: {
  label: string;
  value: string;
  description: string;
}) {
  return (
    <Stack gap="xs">
      <Text size="sm" c="dimmed">
        {label}
      </Text>
      <Group align="baseline" gap="xs">
        <Text size="displaySm" fw={FONT_WEIGHTS.bold}>
          {value}
        </Text>
        <Text size="sm" c="dimmed">
          {description}
        </Text>
      </Group>
    </Stack>
  );
}

export default function AumAndFreshnessCard({
  connectedAum,
  healthyProviderCount,
  totalProviderCount,
}: AumAndFreshnessCardProps) {
  const freshnessPercentage =
    totalProviderCount > 0 ? Math.round((healthyProviderCount / totalProviderCount) * 100) : 0;

  return (
    <Paper withBorder p="md" radius="md" h="100%">
      <Stack gap="md" justify="space-between" h="100%">
        <StatSection
          label="Connected AUM"
          value={formatAbbreviatedCurrency(connectedAum)}
          description="AUM with live valuations"
        />
        <Divider />
        <StatSection
          label="Data freshness"
          value={`${freshnessPercentage}%`}
          description="of connected products updated in the last 24 hours"
        />
      </Stack>
    </Paper>
  );
}
